import { MOBILE_BREAKPOINT_PX } from '@danda/shared';

/**
 * Detects whether the current browser is running on a mobile platform
 * (iOS or Android). Used by the narrow-viewport gate so a desktop user
 * resizing their window doesn't get bounced to /get-the-app: only an
 * actual phone/tablet should be redirected to the install store.
 */
export function isMobilePlatform(): boolean {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return true;
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  // iPadOS 13+ defaults to "Request Desktop Site," masking its UA as
  // Macintosh. No Mac ships with a touchscreen, so a Mac UA reporting
  // multi-touch is an iPad in disguise.
  if (/Macintosh/i.test(ua) && (navigator.maxTouchPoints ?? 0) > 1) return true;
  return false;
}

/**
 * The install-store gate: true when the visitor is on an actual phone/tablet
 * AND the viewport is phone-narrow. Game surfaces (/signup, /lobby, /play)
 * redirect to /get-the-app when this holds; the web game is designed for big
 * screens and mobile players belong in the native apps.
 */
export function shouldGateToApp(): boolean {
  return isMobilePlatform() && window.innerWidth < MOBILE_BREAKPOINT_PX;
}
